<template>
    <div>
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <Table ref="selectionTable" :max-height="height" :data="showData" :columns="showColumns" stripe highlight-row
            border @on-current-change="onSelectionTableChange"></Table>
        <Row style="padding:10px 0px 0px 0px">
            <Col span=3 style="padding:0px 5px 0px 0px">
            <Button long type="success" @click="onClickInsert">添加{{typeName}}</Button>
            </Col>
            <Col span=3 style="padding:0px 5px 0px 0px">
            <Button long type="warning" @click="onClickUpdate">修改{{typeName}}</Button>
            </Col>
            <Col span=3 style="padding:0px 5px 0px 0px">
            <Button long type="error" @click="onClickDelete">删除{{typeName}}</Button>
            </Col>
            <Col span=15>
            <Page :current="currentPage" :total="dataCount" :page-size="pageSize" show-sizer show-total @on-change="changePage"
                @on-page-size-change="changePageSize" style="text-align:right"></Page>
            </Col>
        </Row>

        <!-- 模态框insert -->
        <Modal v-model="isShowInsertModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#19be6b;text-align:center">
                <Icon type="md-create" />
                <span>添加{{typeName}}</span>
            </p>
            <Form ref="formInsert" :label-width="110" :rules="ruleInsert" :model="formInsert">
                <FormItem prop="dictionaryName" label="厂家名称：">
                    <Input v-model="formInsert.dictionaryName" placeholder="请输入厂家名称..."></Input>
                </FormItem>
                <FormItem prop="dictionaryRemark" label="厂家备注：">
                    <Input v-model="formInsert.dictionaryRemark" placeholder="请输入厂家备注..."></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="success" size="large" long :loading="isLoadingButton" @click="commitInsert">添加</Button>
            </div>
        </Modal>

        <!-- 模态框update -->
        <Modal v-model="isShowUpdateModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#ff9900;text-align:center">
                <Icon type="md-create" />
                <span>修改{{typeName}}</span>
            </p>
            <Form ref="formUpdate" :label-width="110" :rules="ruleInsert" :model="formUpdate">
                <FormItem prop="dictionaryName" label="厂家名称：">
                    <Input v-model="formUpdate.dictionaryName" placeholder="请输入厂家名称..."></Input>
                </FormItem>
                <FormItem prop="dictionaryRemark" label="厂家备注：">
                    <Input v-model="formUpdate.dictionaryRemark" placeholder="请输入厂家备注..."></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="warning" size="large" long :loading="isLoadingButton" @click="commitUpdate">修改</Button>
            </div>
        </Modal>

        <!-- 模态框delete -->
        <Modal v-model="isShowDeleteModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#ed4014;text-align:center">
                <Icon type="md-create" />
                <span>删除{{typeName}}</span>
            </p>
            <div style="color:#ed4014;text-align:center">
                是否确认删除所选{{typeName}}？
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="isLoadingButton" @click="commitDelete">删除</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.showColumns = [
                {
                    title: "厂家名称",
                    key: "dictionaryName"
                },
                {
                    title: "厂家备注",
                    key: "dictionaryRemark"
                },
                {
                    title: "创建人",
                    key: "createdBy"
                },
                {
                    title: "修改人",
                    key: "lastModifiedBy"
                }
                
            ];
            this.showPage();
        },
        data() {
            // const validateyyyy = (rule, value, callback) => {
            //     if (value.length === 0) {
            //         callback(new Error('请输入yyyy...'));
            //     } else {
            //         callback();
            //     }
            // };
            return {
                typeName: "设备厂家",
                urlClass: "dictionary",
                dictionaryName: "manufacturer",
                height: window.innerHeight,
                isLoadingButton: false,
                isShowInsertModal: false,
                isShowUpdateModal: false,
                isShowDeleteModal: false,
                isShowTarget: false,
                isSpinShow: false,
                currentPage: 1,
                dataCount: 0,
                pageSize: 10,
                showData: [],
                showColumns: [],
                selectedData: null,
                formInsert: {
                    dictionaryId: "manufacturer",
                    dictionaryName: "",
                    dictionaryPid: "manufacturer",
                    dictionaryPname: "设备厂家",
                    dictionaryRemark: ""
                },
                formUpdate: {
                    dictionaryName: "",
                    dictionaryPid: "manufacturer",
                    dictionaryPname: "设备厂家",
                    dictionaryRemark: ""
                },
                ruleInsert: {
                    // xxxx: [{
                    //     required: true,
                    //     message: '请输入xxxx...',
                    //     trigger: 'blur'
                    // }],
                    // yyyy: [{
                    //     required: true,
                    //     validator: validateyyyy,
                    //     trigger: 'change'
                    // }]
                }
            }
        },
        methods: {
            onSelectionTableChange(currentRow) {
                this.selectedData = currentRow;
            },
            onClickInsert() {
                this.isShowInsertModal = true;
            },
            onClickUpdate() {
                if (this.selectedData) {
                    this.formUpdate = this.selectedData;
                    this.isShowUpdateModal = true;
                } else {
                    this.$Notice.warning({
                        title: "警告",
                        desc: "请选择一条数据！"
                    });
                }
            },
            onClickDelete() {
                if (this.selectedData) {
                    this.isShowDeleteModal = true;
                } else {
                    this.$Notice.warning({
                        title: "警告",
                        desc: "请选择一条数据！"
                    });
                }
            },
            commitInsert() {
                let that = this;
                that.$refs['formInsert'].validate((valid) => {
                    if (valid) {
                        that.isLoadingButton = true;
                        $.ajax({
                            url: "/api/" + that.urlClass + "/insert",
                            contentType: "application/json",
                            type: "post",
                            data: JSON.stringify(that.formInsert),
                            dataType: "json",
                            success: function(data) {
                                if (data.errorCode != 0) {
                                    that.$Notice.error({
                                        title: "异常",
                                        desc: data.errorInfo
                                    });
                                    return;
                                }
                                that.showPage();
                            },
                            error: function(textStatus) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: "接口请求异常"
                                });
                            },
                            complete: function(){
                                that.isLoadingButton = false;
                                that.isShowInsertModal = false;
                            }
                        });
                    }
                });
            },
            commitUpdate() {
                let that = this;
                that.$refs['formUpdate'].validate((valid) => {
                    if (valid) {
                        that.isLoadingButton = true;
                        $.ajax({
                            url: "/api/" + that.urlClass + "/update",
                            contentType: "application/json",
                            type: "post",
                            data: JSON.stringify(that.formUpdate),
                            dataType: "json",
                            success: function(data) {
                                if (data.errorCode != 0) {
                                    that.$Notice.error({
                                        title: "异常",
                                        desc: data.errorInfo
                                    });
                                    return;
                                }
                                that.showPage();
                            },
                            error: function(textStatus) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: "接口请求异常"
                                });
                            },
                            complete: function(){
                                that.isLoadingButton = false;
                                that.isShowUpdateModal = false;
                            }
                        });
                    }
                });
            },
            commitDelete() {
                let that = this;
                that.isLoadingButton = true;
                $.ajax({
                    url: "/api/" + that.urlClass + "/delete",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify(that.selectedData),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.showPage();
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function(){
                        that.isLoadingButton = false;
                        that.isShowDeleteModal = false;
                    }
                });
            },
            showPage() {
                let that = this;
                that.isSpinShow = true;
                $.ajax({
                    url: "/api/" + that.urlClass + "/selectPage?page=" +
                        that.currentPage +
                        "&pageAmount=" +
                        that.pageSize,
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify({
                        dictionaryPid: that.dictionaryName
                    }),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.showData = data.body.resultList;
                        that.dataCount = data.body.amount;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function(){
                      that.isSpinShow = false;
                    }
                });
            },
            changePage(index) {
                this.currentPage = index;
                this.showPage();
            },
            changePageSize(size) {
                this.pageSize = size;
                this.showPage();
            }
        }
    }
</script>

<style>
</style>
